import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

const WindWaterSensors = (props) => {
	const [showBothSensors, setShowBothSensors] = useState(false);
	const [sensors, setSensors] = useState([{ label: "", value: "" }]);

	useEffect(() => {
		if (props.sensors != null && props.sensors.length === 2)
			setShowBothSensors(true);

		setSensors(props.sensors);
	}, [props.sensors]);

	return (
		<Row style={{ padding: "5px 0", borderBottom: "1px solid #666" }}>
			{showBothSensors ? (
				<>
					<Col md="6" style={{ borderRight: "1px solid #666" }}>
						<h6>{sensors[0].label}</h6>
						<p style={sensors[0].style}>{sensors[0].value}</p>
					</Col>
					<Col md="6">
						<h6>{sensors[1].label}</h6>
						<p style={sensors[1].style}>{sensors[1].value}</p>
					</Col>
				</>
			) : (
				<Col md="12">
					<h6>{sensors[0].label}</h6>
					<p style={sensors[0].style}>{sensors[0].value}</p>
				</Col>
			)}
		</Row>
	);
};

export default WindWaterSensors;
